import React, { useEffect } from 'react';

const { Kakao } = window;

function KakaoShareBtn(props) {
  useEffect(() => {
    initKakao();
  }, []);

  const initKakao = () => {
    if (Kakao) {
      // 중복 init 방지
      if (!Kakao.isInitialized()) {
        Kakao.init(process.env.REACT_APP_KAKAO_API_KEY);
      }
    }
  };

  return (
    <div style={{ marginTop: '30px' }}>
      <button
        id='kakao-btn'
        onClick={props.onClick}
        style={{
          border: 'none',
          outline: 'none',
          width: '250px',
          height: '70px',
          background: '#fff',
          cursor: 'pointer',
        }}
      >
        <img
          style={{
            width: '100%',
          }}
          src={`https://res.cloudinary.com/${process.env.REACT_APP_CLOUD_NAME}/image/upload/v1622714759/icon/k_share_mhhwkl.png`}
          alt='kakao-share'
        />
      </button>
    </div>
  );
}

export default KakaoShareBtn;
